module.exports = __webpack_public_path__ + "assets/font/Acoucou.svg";